module.exports = __webpack_public_path__ + "img/Somalia.258cf0ab.svg";